import React from "react";

import './contact.styl'

export default ({ data }) =>
  <div className="ContentsContainer Services">
    <h1>
      ¿ Hablamos ?
    </h1>
    <p className="intro">
      Comunícate con nosotros.
      <a href="tel:+573005215073"> 3005215073</a>
    </p>
    <form className="Form" name="contact" method="post" netlify>
      <p>
        <input type="text" name="name" placeholder="Nombres" /> 
      </p>
      <p>
        <input type="email" name="email" placeholder="Email" />
      </p>
      <p>
        <input type="phone" name="phone" placeholder="Teléfono" />
      </p>
      <p>
        <textarea name="message" placeholder="Mensaje" ></textarea>
      </p>
      <p>
        <button type="submit">Enviar</button>
      </p>
  </form>
  </div>

export const query = graphql`
  query ContactQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/contact.js